export { default as Img200 } from './processed/200/Death-Of-Stalin-The.jpg';
export { default as Img400 } from './processed/400/Death-Of-Stalin-The.jpg';
export { default as Imgthumb } from './processed/thumb/Death-Of-Stalin-The.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Death-Of-Stalin-The.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Death-Of-Stalin-The.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      225,
      25,
      38
    ],
    "_population": 607,
    "_hsl": [
      0.9891666666666666,
      0.8,
      0.49019607843137253
    ]
  },
  "LightVibrant": {
    "_rgb": [
      237,
      192,
      116
    ],
    "_population": 5,
    "_hsl": [
      0.10468319559228649,
      0.7707006369426752,
      0.692156862745098
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      129,
      6,
      13
    ],
    "_population": 749,
    "_hsl": [
      0.9905149051490515,
      0.911111111111111,
      0.2647058823529412
    ]
  },
  "Muted": {
    "_rgb": [
      137,
      108,
      93
    ],
    "_population": 1486,
    "_hsl": [
      0.05681818181818183,
      0.19130434782608696,
      0.4509803921568627
    ]
  },
  "LightMuted": {
    "_rgb": [
      212,
      193,
      176
    ],
    "_population": 112,
    "_hsl": [
      0.07870370370370365,
      0.29508196721311497,
      0.7607843137254902
    ]
  },
  "DarkMuted": {
    "_rgb": [
      75,
      55,
      50
    ],
    "_population": 1857,
    "_hsl": [
      0.033333333333333354,
      0.2,
      0.2450980392156863
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Death-Of-Stalin-The.js